import AppForms from "@toothfairy/shared-ui/AppForms";
import React, { useEffect, useRef, useState } from "react";
import { View } from "react-native";
import AppToast from "@toothfairy/shared-ui/AppToast";
import QaHiringTemplateView from "./QaHiringTemplateView";
import connectionsHelper from "../../../../../API/Connections/connectionsHelper";
import useWorkspaces from "../../../../../Hooks/useWorkspaces";
import execEnvsHelper from "../../../../../API/ExecutionEnvironments/execEnvsHelper";
import AgentFunctions from "../../../../../API/AgentFunctions";
import functionsHelper from "../../../../../API/Functions/functionsHelper";
import Agents from "../../../../../API/Agents";
import ToothFairyLoadingPlaceholder from "../../../../../Components/ToothFairyComponents/ToothFairyLoadingPlaceholder";

const QaHiringTemplate = ({
  item,
  setIsHiringTemplateModalOpen,
  setShowPreselectionModal,
}) => {
  const [validationSchema, setValidationSchema] = useState({});
  const [initialFormValues, setInitialFormValues] = useState({});
  const [excludedResources, setExcludedResources] = useState([]);
  const [formKey, setFormKey] = useState(Date.now());

  const AppToasty = AppToast.useToast();
  const [isLoading, setIsLoading] = useState(false);
  const { getActiveWorkspace } = useWorkspaces();
  const ref = useRef();
  const fields = item?.agentHiringTemplate?.fields;
  const resources = item?.agentHiringTemplate?.resources;
  const handleTick = (u, _v) => {
    if (_v == false) {
      setExcludedResources([...excludedResources, u?.id]);
    } else {
      setExcludedResources(excludedResources.filter((i) => i !== u?.id));
    }
  };

  function generateYupSchema(fields) {
    let schema = {};
    let initialValues = {};
    fields.forEach((field) => {
      // add a rule that says [object Object] is not a valid value
      schema[field.name] = AppForms.yup.string().required().label(field.label);
      // .test("not-valid-value", "Required", (value) => {
      //   return value !== "[object Object]";
      // });
      initialValues[field.name] = null;
    });
    setValidationSchema(AppForms.yup.object().shape(schema));
    setInitialFormValues(initialValues);
  }
  const convertTemplateToSchema = (fields) => {
    const schema = generateYupSchema(fields);
    return schema;
  };
  const entityCleanup = (e) => {
    delete e?._lastChangedAt;
    delete e?.createdAt;
    delete e?.updatedAt;
    delete e?._deleted;
    delete e?.__typename;
    delete e?.id;
    return e;
  };
  const handleFormSubmission = async (values) => {
    const new_functions = [];
    const new_code_exec_envs = [];
    const new_datasources = [];
    try {
      setIsLoading(true);

      for (i in resources?.dataSources) {
        let dataSource = resources?.dataSources[i];

        if (!excludedResources?.includes(dataSource.id)) {
          // pull the data source from the DB using the id
          db_connection = await connectionsHelper.getDatabaseConnection(
            dataSource.id
          );
          db_connection = entityCleanup(
            db_connection?.data?.getDatabaseConnection
          );

          db_connection["passwordSecret"] = `${getActiveWorkspace()?.id}/${
            values[dataSource?.requiredSecrets[0]]
          }`;
          db_connection["workspaceID"] = getActiveWorkspace()?.id;
          // associate the secrets
          // create the datasource for the workspace
          const new_db_connection =
            await connectionsHelper.createDatabaseConnection(db_connection);
          new_datasources.push(
            new_db_connection?.data?.createDatabaseConnection?.id
          );
        }
      }
      for (i in resources?.executionEnvironments) {
        let executionEnv = resources?.executionEnvironments[i];

        if (!excludedResources?.includes(executionEnv.id)) {
          // pull the data source from the DB using the id
          execution_env =
            await execEnvsHelper.getCustomCodeExecutionEnvironment(
              executionEnv.id
            );
          execution_env = entityCleanup(
            execution_env?.data?.getCustomCodeExecutionEnvironment
          );
          if (executionEnv?.requiredSecrets?.length > 0)
            execution_env["customExecutionSecrets"] = JSON.stringify(
              executionEnv?.requiredSecrets.map((secret) => {
                return `${getActiveWorkspace()?.id}/${values[secret]}`;
              })
            );

          execution_env["workspaceID"] = getActiveWorkspace()?.id;
          // associate the secrets
          // create the executionEnv for the workspace

          const new_execution_env =
            await execEnvsHelper.createCustomCodeExecutionEnvironment(
              execution_env
            );
          new_code_exec_envs.push(
            new_execution_env?.data?.createCustomCodeExecutionEnvironment?.id
          );
        }
      }
      for (i in resources?.functions) {
        let AIfunction = resources?.functions[i];

        if (!excludedResources?.includes(AIfunction.id)) {
          // pull the data source from the DB using the id
          ai_function = await functionsHelper.getAgentFunction(AIfunction.id);
          ai_function = entityCleanup(ai_function?.data?.getAgentFunction);
          if (AIfunction?.requiredSecrets?.length > 0)
            ai_function["authorisationID"] =
              values[AIfunction?.requiredSecrets[0]];

          ai_function["workspaceID"] = getActiveWorkspace()?.id;
          // associate the secrets
          // create the AIfunction for the workspace

          const new_ai_function = await functionsHelper.createAgentFunction(
            ai_function
          );
          new_functions.push(new_ai_function?.data?.createAgentFunction?.id);
        }
      }
      const purifiedItem = entityCleanup(item);
      const newAgent = {
        ...purifiedItem,
        agentHiringTemplate: null,
        parentAgentID: null,
        parentChatID: null,
        workspaceID: getActiveWorkspace()?.id,
        agentFunctions: new_functions,
        customCodeExecutionEnvironments: new_code_exec_envs,
      };

      const new_agent = await Agents.createAgent(newAgent);
      AppToasty.show("Agent created successfully", {
        placement: "bottom",
        type: "success",
      });
      setIsHiringTemplateModalOpen(false);
      setShowPreselectionModal(false);
    } catch (error) {
      console.error(error);
      AppToasty.show("Agent could not be created", {
        placement: "bottom",
        type: "danger",
      });
      for (const id of new_functions) {
        await functionsHelper.deleteAgentFunction(id);
      }
      for (const id of new_code_exec_envs) {
        await execEnvsHelper.deleteCustomCodeExecutionEnvironment(id);
      }
      for (const id of new_datasources) {
        await connectionsHelper.deleteDatabaseConnection(id);
      }
      AppToasty.show("Resources creation rollback succesfull", {
        placement: "bottom",
        type: "warning",
      });
    } finally {
      setIsLoading(false);
    }

    // keep track of all ids and then associate them to the agent when created specifically customCodeExecutionEnvironments and agentFunctions
    // create the agent with these fields populated
  };
  const convertTemplateToFormFields = (fields) => {
    try {
      setFormFields(fields);
    } catch (error) {
      console.error(error);
      setFormFields([]);
    }
  };
  const generateValidationSchema = (fields) => {
    try {
      convertTemplateToSchema(fields);
      convertTemplateToFormFields(fields);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    generateValidationSchema(fields);
  }, [JSON.stringify(fields)]);

  useEffect(() => {
    if (item?.id) setFormKey(Date.now().toString());
  }, [item?.id]);

  return isLoading ? (
    <ToothFairyLoadingPlaceholder caption="Setting the agent..." />
  ) : (
    <View>
      <AppForms.AppForm
        initialValues={initialFormValues}
        onSubmit={handleFormSubmission}
        validationSchema={validationSchema}
        enableReinitialize
        ref={ref}
        key={formKey}
      >
        <QaHiringTemplateView
          agentHiringTemplate={item?.agentHiringTemplate}
          handleTick={handleTick}
          excludedResources={excludedResources}
        />
      </AppForms.AppForm>
    </View>
  );
};

export default QaHiringTemplate;
